// Module
var code = " <content-host></content-host> ";
// Exports
module.exports = code;